module.exports = __webpack_public_path__ + "static/img/qq.07a0676.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qq.png
// module id = CPDY
// module chunks = 1